// extracted by mini-css-extract-plugin
export default {"heading":"tt-z","corrected":"ut-z","redirectVerbiageContainer":"vt-z","redirectVerbiageText":"wt-z"};